import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { CalendarCheck } from "lucide-react";
import ManageHeader from "@components/ManageHeader";
import DateInput from "@components/forms/DateInput";
import { date_now, lastDayCurrentMonth } from "@global/actions";
import ListingPrice from "./components/ListingPrice";
import { useModal } from "@components/ModalContext";
import {
  loadPrice,
  saveStopSales,
  savePrice,
  loadStopSale,
  loadPriceForms,
} from "./Actions";
const Availability = (props) => {
  const { t } = useTranslation();
  const id = useParams().id;
  const service = useParams().service;
  const [prices, setPrices] = useState([]);
  const paramUseModal = useModal();
  const [dateFrom, setDateFrom] = useState(date_now());
  const [dateTo, setDateTo] = useState(lastDayCurrentMonth());
  const onChangeDate = (from, to) => {
    setDateFrom(from);
    setDateTo(to);
  };
 
  const loadData = async () => {
    setPrices(await loadPrice(id, dateFrom, dateTo));
  };
  const changeStopSales = async (tarif) => {
    tarif.item.is_stop_sales = await saveStopSales(id, tarif.item);
    const data = prices;
    switch (service) {
      case "activity":
        data[tarif.ndex] = tarif.item;
        break;
      case "transfer":
        data[tarif.transferIndex]["vehicles"][tarif.vehicleIndex]["prices"][
          tarif.ndex
        ] = tarif.item;
        break;
      case "hotel":
        data[tarif.roomIndex]["prices"][tarif.ndex] = tarif.item;
        break;
      default:
        break;
    }

    setPrices(data);
    paramUseModal.closeModal();
  };

  const changePrice = async (tarif, index, payload) => {
    const data = prices;
    switch (service) {
      case "activity":
        data[tarif.ndex] = tarif.item;
        break;
      case "transfer":
        data[tarif.transferIndex]["vehicles"][tarif.vehicleIndex]["prices"][
          tarif.ndex
        ] = tarif.item;
        break;
      case "hotel":
        data[tarif.roomIndex]["prices"][tarif.ndex] = tarif.item;
        break;
      default:
        break;
    }

    if (await savePrice(service, id, tarif.item.id, payload)) {
      setPrices(data);
    }

    paramUseModal.closeModal();
  };

  const onStopSales = (tarif) => {
    loadStopSale(tarif, paramUseModal, changeStopSales, t);
  };

  const priceForm = (tarif) => {
    loadPriceForms(tarif, paramUseModal, t, changePrice, service);
  };
useEffect(() => {
  loadData();
}, []);

  return (
    <>
      {" "}
      <ManageHeader
        title={t("")}
        content={t("availability_caption")}
        icon={<CalendarCheck size={25} strokeWidth={1.5} />}
      />
      <div className="row mt-3">
        <div className="col-md-6 col-lg-6 mb-3">
          <DateInput
            leftLabel={t("from")}
            rightLabel={t("to")}
            onDateChange={onChangeDate}
            dateFrom={dateFrom}
            dateTo={dateTo}
          />
        </div>
        <div className="col-md-6 col-lg-1 mb-3 d-flex align-items-end">
          <button
            className="btn-custom w-100 "
            style={{height:"50px"}}
            onClick={() => loadData(0)}
          >
            {t("search")}
          </button>
        </div>
      
      </div>
      <ListingPrice
        t={t}
        productId={id}
        mode={props.profile.mode}
        data={prices}
        onStopSales={onStopSales}
        priceForm={priceForm}
        service={service}
        profile={props.profile}
      />
    </>
  );
};

export default Availability;
